import t9n from "@bimproject/t9n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import BIMClassCard from "./BIMClassCard";
import { useFinder } from "../../../../../../modules/finder";
import { useBIMClasses } from "../../../../../../modules/shared-entities";

export default function BIMClassFinderPlugin(props) {
    const { Component = BIMClassCard, onSelect } = props;

    const bimClasses = useBIMClasses().data?.bimClasses ?? [];

    const { i18n } = useTranslation();

    const { token } = useFinder();

    const filteredBIMClasses = useMemo(
        () => bimClasses
            .filter(
                (bimClass) => !bimClass.metadata.deprecated
            )
            .filter(
                (bimClass) => [
                    bimClass.id.replaceAll("-").toLowerCase() === token.replaceAll("-").toLowerCase(),
                    token.length > 3 && bimClass.id.replaceAll("-").toLowerCase().includes(
                        token.replaceAll("-").toLowerCase()
                    ),
                    bimClass.data.name
                        .map((translatable) => translatable.text)
                        .map((text) => text.toLowerCase())
                        .some((text) => text.includes(token.toLowerCase())),
                ].some(Boolean)
            )
            .sort(
                (a, b) => a.data.name[0].text.localeCompare(b.data.name[0].text),
            ),
        [bimClasses, token],
    );

    return filteredBIMClasses.map(
        (bimClass) => (
            <Component
                { ...bimClass }
                id={ bimClass.id }
                key={ bimClass.id }
                name={ t9n(bimClass.data.name, i18n.language) }
                onClick={ () => onSelect(bimClass) }
                type={ bimClass.data.type }
            />
        )
    );
}
